import React, { useState, useEffect } from "react";
import axios from "axios";
import truckImage from "../assets/truck_silhouette.png";
import "./Despachos.css";
import { toast } from "react-toastify";
import {
  FiCheckCircle,
  FiTruck,
  FiFileText,
  FiPlus,
  FiDownload,
  FiSearch,
  FiTrash2,
  FiRepeat,
  FiEye,
  FiEdit2,
  FiPrinter,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { createPortal } from "react-dom";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_DESPACHOS;

function Despachos() {
  const [envios, setEnvios] = useState([]); // 🚛 Envíos pendientes (camión)
  const [confirmados, setConfirmados] = useState([]); // 📋 Envíos confirmados (tabla)
  const [showSelector, setShowSelector] = useState(false);
  const [productosInventario, setProductosInventario] = useState([]);
  const [seleccionados, setSeleccionados] = useState([]);
  const [busquedaProducto, setBusquedaProducto] = useState("");
  const [showDetalle, setShowDetalle] = useState(null);
  const [editando, setEditando] = useState(false);
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const [showGuiaModal, setShowGuiaModal] = useState(false);
  const [guiaInput, setGuiaInput] = useState("");
  const [transportadoraInput, setTransportadoraInput] = useState("");
  const [valorEnvioInput, setValorEnvioInput] = useState("");
  const [guiaActual, setGuiaActual] = useState("");
  const [detalleDespacho, setDetalleDespacho] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [asignandoBonos, setAsignandoBonos] = useState(false);
  const [loadingDevolucion, setLoadingDevolucion] = useState(false);
  const [tipoDespachoActual, setTipoDespachoActual] = useState("");
  const [confirmandoEnvios, setConfirmandoEnvios] = useState(false);
  const [showLegalizarModal, setShowLegalizarModal] = useState(false);
  const [openEnvio, setOpenEnvio] = useState(false);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  const [filtroResumen, setFiltroResumen] = useState("");

  // === Modal de producto temporal ===
  const [showTemporalModal, setShowTemporalModal] = useState(false);
  const [tempProducto, setTempProducto] = useState({
    nombre: "",
    cantidad: 1,
    tipoPrecio: "coste",
    valorManual: "",
  });

  // === MODAL DE DEVOLUCIONES ===
  const [showDevolucion, setShowDevolucion] = useState(false);
  const [devolucionSeleccion, setDevolucionSeleccion] = useState(null);
  const [devolucionesMap, setDevolucionesMap] = useState({});

  const toTitleCase = (text = "") => {

    const minusculas = [
      "de",
      "del",
      "la",
      "las",
      "el",
      "los",
      "y",
      "e",
      "o",
      "u",
      "en",
      "a",
      "al",
      "por",
      "para",
      "con"
    ];

    return text
      .toLowerCase()
      .split(" ")
      .map((word, index) => {

        if (
          index > 0 &&
          minusculas.includes(word)
        ) {
          return word;
        }

        return (
          word.charAt(0).toUpperCase() +
          word.slice(1)
        );

      })
      .join(" ");
  };

  const imprimirRotulo = () => {

    const contenido =
      detalleDespacho.productos
        ?.map((p) => {

          const sku =
            p.codigo ||
            p.sku ||
            p.SKU ||
            "-";

          return `${p.cantidad} X ${sku} - ${p.nombre}`;

        })
        .join(" | ");

    const ventana = window.open(
      "",
      "_blank",
      "width=900,height=1000"
    );

    ventana.document.write(`
      <html>
  
       <head>
  
          <title>
            Rótulo de despacho
          </title>
  
          <style>
  
            *{
              box-sizing:border-box;
            }
  
            body{
              margin:0;
              padding:30px;
  
              font-family:
                Arial,
                Helvetica,
                sans-serif;
  
              color:#111827;
  
              background:white;
            }
  
            .box{
  
              border:3px solid #111827;
  
              border-radius:12px;
  
              padding:25px;
            }
  
            /* ==========================
               HEADER
            ========================== */
  
            .logo{
              text-align:center;
  
              padding-bottom:20px;
  
              border-bottom:2px solid #111827;
            }
  
            .logo h1{
              margin:0;
  
              font-size:24px;
              font-weight:800;
  
              letter-spacing:0.5px;
            }
  
            .subtitle{
              margin-top:8px;
  
              font-size:13px;
              font-weight:600;
  
              letter-spacing:2px;
  
              color:#6b7280;
            }
  
            /* ==========================
               REMITENTE / DESTINATARIO
            ========================== */
  
            .contact-grid{
  
              display:flex;
  
              gap:20px;
  
              margin-top:25px;
            }
  
            .contact-box{
  
              flex:1;
  
              border:1px solid #d1d5db;
  
              border-radius:10px;
  
              padding:15px;
            }
  
            .title{
  
              font-size:14px;
              font-weight:700;
  
              color:#111827;
  
              border-bottom:1px solid #e5e7eb;
  
              padding-bottom:8px;
  
              margin-bottom:12px;
  
              text-transform:uppercase;
            }
  
            .contact-box strong{
              font-size:15px;
            }
  
            .contact-box p{
              margin:5px 0;
              line-height:1.5;
            }
  
            /* ==========================
               CONTENIDO
            ========================== */
  
            .section{
  
              margin-top:20px;
  
              border:1px solid #d1d5db;
  
              border-radius:10px;
  
              padding:15px;
            }
  
            .contenido{
  
              line-height:1.8;
              font-size:15px;
            }
  
            /* ==========================
               INFO ORDEN
            ========================== */
  
            .info-grid{
  
              display:grid;
  
              grid-template-columns:
                repeat(4,1fr);
  
              gap:12px;
  
              margin-top:20px;
            }
  
            .info-box{
 
             border:1px solid #d1d5db;
  
              border-radius:10px;
  
              padding:12px;
            }
  
            .info-label{
  
              font-size:11px;
  
              font-weight:700;
  
              color:#6b7280;
  
              text-transform:uppercase;
  
              margin-bottom:5px;
            }
  
            .info-value{
  
              font-size:15px;
  
              font-weight:700;
            }
  
            /* ==========================
               FOOTER
            ========================== */
  
            .footer{
  
              margin-top:25px;
  
              text-align:center;
  
              font-size:20px;
  
              font-weight:800;
  
              letter-spacing:1px;
  
              border-top:3px solid #111827;
  
              padding-top:15px;
            }
  
            @media print{
  
              body{
                padding:0;
              }
 
              .box{
                border:none;
              }
  
            }
  
          </style>
  
        </head>
  
        <body>
  
          <div class="box">
  
            <div class="logo">
  
              <h1>
                FONDO DE EMPLEADOS DE MANPOWERGROUP
              </h1>
  
              <div class="subtitle">
                RÓTULO DE DESPACHO • ${detalleDespacho.wooOrderId || detalleDespacho.codigo} • ${new Date().toLocaleDateString("es-CO")}
              </div>
  
            </div>
  
            <div class="contact-grid">
  
              <div class="contact-box">
  
                <div class="title">
                  Remitente
                </div>
  
                <strong>
                  Fondo de Empleados de ManpowerGroup
                </strong>
  
                <p>
                  NIT: 830077032-8
                </p>
  
                <p>
                  Cra 48 # 10 - 45 OF. 809
                </p>
  
                <p>
                  Centro Comercial Monterrey
                </p>
  
                <p>
                  Medellín - Antioquia
                </p>
  
                <p>
                  (604) 5906857
                </p>
  
                <p>
                  3147289628
                </p>
  
              </div>
  
              <div class="contact-box">
  
                <div class="title">
                  Destinatario
                </div>
  
                <strong>
                  ${detalleDespacho.cliente || "-"}
                </strong>
  
                <p>
                  Documento:
                  ${detalleDespacho.identificacion || "-"}
                </p>
  
                <p>
                  Celular:
                  ${detalleDespacho.celular || "-"}
                </p>
  
                <p>
                  ${detalleDespacho.departamento || ""}
                  -
                  ${detalleDespacho.ciudad || ""}
                </p>
  
                <p>
                  ${detalleDespacho.barrio || ""}
                </p>
 
                <p>
                  ${detalleDespacho.direccion || ""}
                </p>
  
              </div>
  
            </div>
  
            <div class="section">
  
              <div class="title">
                Contenido
              </div>
  
              <div class="contenido">
                ${contenido}
              </div>
  
            </div>
  
            <div class="info-grid">
  
              <div class="info-box">
  
                <div class="info-label">
                  Transportadora
                </div>
  
                <div class="info-value">
                  ${detalleDespacho.transportadora || "-"}
                </div>
  
              </div>
  
              <div class="info-box">
  
                <div class="info-label">
                  Guía
                </div>
  
                <div class="info-value">
                  ${detalleDespacho.guia || "-"}
                </div>
  
              </div>
  
              <div class="info-box">
  
                <div class="info-label">
                  Costo Envío
                </div>
  
                <div class="info-value">
                  ${detalleDespacho.valorEnvio.toLocaleString("es-CO") || "-"}
                </div>
  
              </div>
  
              <div class="info-box">
  
                <div class="info-label">
                  Recibió
                </div>
  
                <div class="info-value">
                  
                </div>
  
              </div>
  
            </div>
  
            <div class="footer">
              ⚠ MANIPULAR CON CUIDADO ⚠
            </div>
  
          </div>
  
          <script>
  
            window.onload = () => {
  
              window.print();
  
            }
  
          </script>
  
        </body>
  
      </html>
    `);

    ventana.document.close();

  };

  const confirmarLegalizacion = async () => {

    try {

      await axios.post(
        `${API}/${detalleDespacho._id}/legalizar`
      );

      toast.success(
        "Despacho legalizado correctamente."
      );

      const ahora = new Date();

      setDetalleDespacho({
        ...detalleDespacho,
        legalizadoContabilidad: true,
        fechaLegalizacion: ahora,
      });

      setShowLegalizarModal(false);

      await cargarDespachos();

    } catch (err) {

      console.error(err);

      toast.error(
        err?.response?.data?.error ||
        "Error legalizando despacho"
      );
    }
  };

  const [showEditarDireccion, setShowEditarDireccion] =
    useState(false);

  const [direccionEdit, setDireccionEdit] =
    useState({
      departamento: "",
      ciudad: "",
      barrio: "",
      direccion: "",
    });

  const cargarDespachos = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        process.env.REACT_APP_API_DESPACHOS,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setConfirmados(res.data || []);
    } catch (err) {
      console.error(
        "❌ Error al cargar despachos:",
        err
      );
    }
  };

  useEffect(() => {

    cargarDespachos();

  }, []);

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_API_INVENTARIO}/items?limit=5000`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        let disponibles = res.data?.data || [];

        // Filtrar solo con stock
        disponibles = disponibles.filter((item) => item.quantity > 0);

        // Normalizar nombres y ordenar alfabéticamente
        disponibles.sort((a, b) => {
          const nombreA = (a.name || a.nombre || "").toString().trim().toLowerCase();
          const nombreB = (b.name || b.nombre || "").toString().trim().toLowerCase();
          return nombreA.localeCompare(nombreB, "es", { sensitivity: "base" });
        });

        setProductosInventario(disponibles);
        console.log(`📦 ${disponibles.length} productos con stock cargados`);
      } catch (err) {
        console.error("❌ Error al cargar productos de inventario:", err);
      }
    };

    fetchProductos();
  }, []);

  const [form, setForm] = useState({
    id: null,
    codigo: "",
    guia: "",
    cliente: "",
    identificacion: "",
    celular: "",
    origen: "",
    departamento: "",
    ciudad: "",
    barrio: "",
    direccion: "",
    tipoEnvio: "",
    productos: [],
    fecha: "",
    esBeneficio: false,
    programaBeneficio: "",
  });

  const productosFiltrados =
    productosInventario.filter((p) => {

      const q =
        busquedaProducto.toLowerCase();

      const matchBusqueda =

        (p.name || "")
          .toLowerCase()
          .includes(q)

        ||

        (p.code || "")
          .toLowerCase()
          .includes(q);

      // =====================================
      // FILTRO POR TIPO DESPACHO
      // =====================================

      const tipoProducto =
        (p.type || "")
          .toLowerCase();

      const tipoActual =
        (form.tipoDespacho || "")
          .toLowerCase();

      const matchTipo =
        tipoProducto === tipoActual;

      return (
        matchBusqueda &&
        matchTipo
      );
    });

  // === Filtros y búsqueda ===
  const [busqueda, setBusqueda] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroDestino, setFiltroDestino] = useState("");
  const [filtroEstadoTabla, setFiltroEstadoTabla] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");

  // === Generar código de despacho ===
  const generarCodigo = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from({ length: 6 }, () =>
      chars.charAt(Math.floor(Math.random() * chars.length))
    ).join("");
  };

  // Departamentos 
  const departamentosColombia = [
    "Amazonas",
    "Antioquia",
    "Arauca",
    "Atlántico",
    "Bolívar",
    "Boyacá",
    "Caldas",
    "Caquetá",
    "Casanare",
    "Cauca",
    "Cesar",
    "Chocó",
    "Córdoba",
    "Cundinamarca",
    "Guainía",
    "Guaviare",
    "Huila",
    "La Guajira",
    "Magdalena",
    "Meta",
    "Nariño",
    "Norte de Santander",
    "Putumayo",
    "Quindío",
    "Risaralda",
    "San Andrés y Providencia",
    "Santander",
    "Sucre",
    "Tolima",
    "Valle del Cauca",
    "Vaupés",
    "Vichada",
  ];

  // === Abrir modal (nuevo) ===
  const openModal = () => {

    let tipoPermitido = tipoDespachoActual;

    if (
      envios.length > 0 &&
      envios[0]?.tipoDespacho
    ) {
      tipoPermitido =
        envios[0].tipoDespacho;
    }

    setForm({
      id: null,
      codigo: generarCodigo(),

      guia:
        tipoDespachoActual === "fisico"
          ? guiaActual || ""
          : "",

      cliente: "",
      identificacion: "",
      celular: "",

      origen: "",

      departamento: "",
      ciudad: "",
      barrio: "",
      direccion: "",

      tipoEnvio: "",

      tipoDespacho: tipoPermitido,

      // NUEVO
      esBeneficio: false,
      programaBeneficio: "",

      productos: [],

      fecha: new Date().toLocaleDateString(),
    });

    setEditando(false);

    setShowModal(true);
  };

  // === Guardar / actualizar ===
  const guardarEnvio = () => {

    // =====================================
    // VALIDACIÓN CLIENTE
    // =====================================

    if (
      !form.cliente ||
      !form.identificacion
    ) {

      toast.error(
        "Completa los datos del cliente."
      );

      return;
    }

    // =====================================
    // VALIDACIÓN DESTINO SOLO FÍSICOS
    // =====================================

    if (
      form.tipoDespacho === "fisico"
    ) {

      if (
        !form.departamento ||
        !form.ciudad ||
        !form.direccion
      ) {

        toast.error(
          "Completa los datos de destino."
        );

        return;
      }
    }

    // =====================================
    // VALIDACIÓN BENEFICIO
    // =====================================

    if (
      form.esBeneficio &&
      !form.programaBeneficio
    ) {
      return toast.warn(
        "Debes seleccionar un programa."
      );
    }

    const payload = {
      ...form,

      guia: "",
    };

    if (editando) {

      const actualizados =
        envios.map((e) =>
          e.id === payload.id
            ? payload
            : e
        );

      setEnvios(actualizados);

    } else {

      const nuevoEnvio = {
        id: Date.now(),
        ...payload,
      };

      setEnvios([
        ...envios,
        nuevoEnvio
      ]);
    }

    setShowModal(false);
  };

  // === Confirmar todos los envíos (pasan a tabla) ===
  const confirmarEnvios = async () => {

    if (envios.length === 0) {

      return toast.error(
        "No hay ordenes registradas."
      );
    }

    const lote = envios.map((e) => {

      const total =
        e.productos.reduce((acc, p) => {

          let valor = 0;

          if (e.esBeneficio) {

            valor = Number(p.costPrice || 0);

          } else if (p.tipoPrecio === "manual") {

            valor = Number(p.valorManual || 0);

          } else if (p.tipoPrecio === "venta") {

            valor = Number(p.salePrice || 0);

          } else {

            valor = Number(p.costPrice || 0);
          }

          return (
            acc +
            valor * (p.cantidad || 1)
          );

        }, 0);

      // =====================================
      // ESTADO SEGÚN TIPO
      // =====================================

      let estado = "pendiente";
      let fechaCompletado = null;

      // FÍSICO
      if (e.tipoDespacho === "fisico") {

        estado = "creado";

        fechaCompletado = null;
      }

      // DIGITAL
      if (e.tipoDespacho === "digital") {

        estado = "pendiente_asignacion";
      }

      // SERVICIO
      if (e.tipoDespacho === "servicio") {

        estado = "pendiente_proveedor";
      }

      return {

        ...e,

        productos: e.productos.map((p) => ({
          ...p,

          // ✅ Si es beneficio, siempre coste
          tipoPrecio: e.esBeneficio
            ? "coste"
            : (p.tipoPrecio || "venta")
        })),

        guia:
          e.tipoDespacho === "fisico"
            ? (e.guia || guiaActual || "").trim()
            : "",

        codigo:
          e.codigo || generarCodigo(),

        fecha:
          new Date().toISOString(),

        total,

        estado,

        fechaCompletado,
      };
    });

    try {

      for (const envio of lote) {

        const token = localStorage.getItem("token");

        const res = await axios.post(
          `${process.env.REACT_APP_API_DESPACHOS}`,
          envio,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log(
          "✅ RESPUESTA CREAR:",
          res.data
        );

        // =====================================
        // OBTENER ID REAL
        // =====================================

        const despachoId =
          res.data?._id ||
          res.data?.despacho?._id;

        // =====================================
        // VALIDAR ID
        // =====================================

        if (!despachoId) {

          console.error(
            "❌ No llegó ID del despacho",
            res.data
          );

          continue;
        }

        // =====================================
        // DISPARAR BONOS DIGITALES
        // =====================================

        if (
          envio.tipoDespacho === "digital"
        ) {

          try {

            const token = localStorage.getItem("token");

            await axios.post(
              `${API}/${despachoId}/asignar-bonos`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );


            console.log(
              "🎁 Bonos enviados correctamente"
            );

          } catch (err) {

            console.error(
              "❌ Error asignando bonos:",
              err
            );
          }
        }
      }

      await cargarDespachos();

      setEnvios([]);

      setGuiaActual("");

      setTipoDespachoActual("");

      toast.success(
        "Ordenes confirmadas correctamente."
      );

    } catch (err) {

      console.error(
        "❌ Error guardando ordenes:",
        err
      );

      toast.error(
        "No se pudieron guardar las ordenes."
      );
    }
  };


  // === Exportar Excel ===
  const exportarExcel = () => {
    if (filteredEnvios.length === 0)
      return toast.warn("No hay ordenes que coincidan con los filtros actuales.");

    // Crear hoja con detalle completo
    const data = filteredEnvios.map((e) => {
      const totalDevueltos = e.devueltos?.reduce((acc, d) => acc + d.cantidad, 0) || 0;
      const totalProductos = e.productos?.reduce((acc, p) => acc + p.cantidad, 0) || 0;
      const estado =
        totalDevueltos === 0
          ? "Despachado"
          : totalDevueltos < totalProductos
            ? "Devolución parcial"
            : "Devolución total";

      return {
        Orden: e.codigo || "—",
        Fecha: new Date(e.fecha).toLocaleString("es-CO") || "—",
        Tipo_Envío: e.tipoDespacho
          ? e.tipoDespacho.charAt(0).toUpperCase() + e.tipoDespacho.slice(1)
          : "—",
        Transportadora: e.transportadora || "—",
        Guía: e.guia || "—",
        Identificación: e.identificacion || "—",
        Cliente: e.cliente
          ? e.cliente
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
          : "—",
        Celular: e.celular || "—",
        Origen: e.origen
          ? e.origen
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
          : "—",
        Departamento: e.departamento || "—",
        Ciudad: e.ciudad
          ? e.ciudad
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
          : "—",
        Barrio: e.barrio
          ? e.barrio
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
          : "—",
        Dirección: e.direccion
          ? e.direccion
            .toLowerCase()
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ")
          : "—",
        Productos: e.productos
          .map(
            (p) =>
              `${p.codigo || "-"} - ${p.nombre} (${p.cantidad} uds, P.C ${p.costPrice}, P.V ${p.salePrice})`
          )
          .join("; "),
        Devoluciones: e.devueltos?.length
          ? e.devueltos
            .map((d) => {
              const prod = e.productos.find(
                (p) => p._id?.toString() === d.productoId?.toString()
              );
              if (!prod) return "—";
              const valorUnit =
                prod.tipoPrecio === "manual"
                  ? Number(prod.valorManual)
                  : prod.tipoPrecio === "coste"
                    ? Number(prod.costPrice)
                    : Number(prod.salePrice);
              return `${prod.codigo || "-"} - ${prod.nombre} (${d.cantidad} uds, $${valorUnit.toLocaleString(
                "es-CO"
              )} c/u)`;
            })
            .join("; ")
          : "—",
        Total_Orden: e.total || "—",
        Costo_Envío: e.valorEnvio || "—",
        Total_Legalización: e.total + e.valorEnvio || "—",
        Fecha_Completado: e.fechaCompletado
          ? new Date(e.fechaCompletado).toLocaleString("es-CO")
          : "—",
        Fecha_Legalización: e.fechaLegalizacion
          ? new Date(e.fechaLegalizacion).toLocaleString("es-CO")
          : "—",
        Tipo_Legalización: [...new Set(
          e.productos.map(p =>
            p.tipoPrecio === "venta"
              ? "Venta"
              : p.tipoPrecio === "coste"
                ? "Beneficio"
                : p.tipoPrecio
          )
        )].join("; "),
        Programa: e.programaBeneficio || "—",
        Estado: e.estado || "—",
      };
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ordenes Filtradas");
    XLSX.writeFile(wb, "Ordenes_Filtradas.xlsx");
  };


  // === 🔸 Reserva temporal ===
  // Crea un mapa con la cantidad reservada de cada producto en los despachos pendientes
  const getReservedMap = (excludeId = null) => {
    const map = {};
    envios.forEach((env) => {
      if (excludeId && env.id === excludeId) return;
      (env.productos || []).forEach((p) => {
        map[p._id] = (map[p._id] || 0) + Number(p.cantidad || 0);
      });
    });
    return map;
  };

  // Calcula disponibilidad actual (inventario - reservas)
  const getDisponibleAhora = (prodId) => {
    const reservado = getReservedMap(editando ? form.id : null)[prodId] || 0;
    const inventario = productosInventario.find((p) => p._id === prodId)?.quantity ?? 0;
    return Math.max(inventario - reservado, 0);
  };

  // === Manejo de cantidades en el formulario ===
  const setCantidadProducto = (prodId, nuevaCant) => {
    const disponible = getDisponibleAhora(prodId);
    const cant = Math.max(1, Math.min(Number(nuevaCant) || 1, disponible));
    const nuevaLista = form.productos.map((p) =>
      p._id === prodId ? { ...p, cantidad: cant } : p
    );
    setForm({ ...form, productos: nuevaLista });
  };

  const incCantidad = (prodId) => {
    const p = form.productos.find((x) => x._id === prodId);
    if (!p) return;
    setCantidadProducto(prodId, Number(p.cantidad || 1) + 1);
  };

  const decCantidad = (prodId) => {
    const p = form.productos.find((x) => x._id === prodId);
    if (!p) return;
    setCantidadProducto(prodId, Number(p.cantidad || 1) - 1);
  };

  const enviosResumen = (confirmados || []).filter((e) => {

    if (!filtroResumen) return true;

    const estado =
      (e.estado || "").toLowerCase();

    if (filtroResumen === "fisico") {
      return (
        e.tipoDespacho === "fisico" &&
        ![
          "completado",
          "despachado",
          "devolucion_parcial",
          "devuelto",
          "legalizado",
        ].includes(estado)
      );
    }

    if (filtroResumen === "digital") {
      return (
        e.tipoDespacho === "digital" &&
        ![
          "entregado_digital",
          "completado",
          "devolucion_parcial",
          "devuelto",
        ].includes(estado)
      );
    }

    if (filtroResumen === "servicio") {
      return (
        e.tipoDespacho === "servicio" &&
        ![
          "completado",
          "devolucion_parcial",
          "devuelto",
        ].includes(estado)
      );
    }

    return true;
  });

  // === Filtrado por búsqueda y tipo ===
  const filteredEnvios = confirmados.filter((e) => {

    const q = busqueda.toLowerCase();

    // =========================================
    // BUSCADOR GLOBAL
    // =========================================

    const matchBusqueda =

      String(e.wooOrderId || "")
        .toLowerCase()
        .includes(q)

      ||

      String(e.codigo || "")
        .toLowerCase()
        .includes(q)

      ||

      String(e.guia || "")
        .toLowerCase()
        .includes(q)

      ||

      String(e.cliente || "")
        .toLowerCase()
        .includes(q)

      ||

      String(e.identificacion || "")
        .toLowerCase()
        .includes(q)

      ||

      String(e.celular || "")
        .toLowerCase()
        .includes(q);

    // =========================================
    // FILTRO TIPO
    // =========================================

    const matchTipo =
      filtroTipo
        ? e.tipoDespacho === filtroTipo
        : true;

    // =========================================
    // FILTRO CATEGORÍA
    // =========================================

    const cumpleCategoria =
      !filtroCategoria ||
      (filtroCategoria === "beneficio" && e.esBeneficio) ||
      (filtroCategoria === "venta" && !e.esBeneficio);


    // =========================================
    // FILTRO DESTINO
    // =========================================

    const destinoTexto = `
      ${e.departamento || ""}
      ${e.ciudad || ""}
      ${e.barrio || ""}
      ${e.direccion || ""}
    `.toLowerCase();

    const matchDestino =
      filtroDestino
        ? destinoTexto.includes(
          filtroDestino.toLowerCase()
        )
        : true;

    // =========================================
    // FILTRO ESTADO
    // =========================================

    const estado = (e.estado || "").toLowerCase();

    let estadoTexto = "en espera";

    if (estado === "creado") {
      estadoTexto = "creado";
    }

    if (
      [
        "completado",
        "entregado_digital",
        "despachado",
      ].includes(estado)
    ) {
      estadoTexto = "despachado";
    }

    if (estado === "devolucion_parcial") {
      estadoTexto = "devolucion_parcial";
    }

    if (estado === "devuelto") {
      estadoTexto = "devuelto";
    }

    if (estado === "legalizado") {
      estadoTexto = "legalizado";
    }

    const matchEstado =
      filtroEstadoTabla
        ? estadoTexto === filtroEstadoTabla
        : true;

    const fechaDespacho =
      e.fecha
        ? new Date(e.fecha)
        : null;

    const matchFecha =
      (!fechaDesde ||
        (
          fechaDespacho &&
          fechaDespacho >= new Date(fechaDesde)
        )) &&
      (!fechaHasta ||
        (
          fechaDespacho &&
          fechaDespacho <= new Date(
            `${fechaHasta}T23:59:59`
          )
        ));

    return (
      matchBusqueda &&
      matchTipo &&
      matchDestino &&
      matchEstado &&
      matchFecha &&
      cumpleCategoria
    );
  });

  useEffect(() => {
    setPage(1);
  }, [filteredEnvios.length]);

  // =========================================
  // DATOS PARA LA TABLA
  // =========================================

  const listaFinal =
    filtroResumen
      ? enviosResumen
      : filteredEnvios;

  // =========================================
  // PAGINACIÓN
  // =========================================

  const start = (page - 1) * itemsPerPage;
  const end = start + itemsPerPage;

  const totalPages = Math.ceil(
    listaFinal.length / itemsPerPage
  );

  const currentPageItems =
    listaFinal.slice(start, end);

  const agregarSeleccionados = () => {
    const nuevos = productosInventario.filter((p) => seleccionados.includes(p._id));
    const yaAgregadosIds = form.productos.map((p) => p._id);

    const productosFormateados = nuevos
      .filter((n) => !yaAgregadosIds.includes(n._id))
      .map((p) => {
        const disponible = getDisponibleAhora(p._id);
        return {
          _id: p._id,
          codigo: p.code || p.codigo || "-",
          nombre: p.name || p.nombre,
          cantidad: Math.min(1, disponible),
          stock: p.quantity,
          costPrice: Number(p.costPrice || 0),
          salePrice: Number(p.salePrice || 0),
          tipoPrecio: "venta", // 👈 por defecto, salida por venta
        };
      })

      .filter((pf) => pf.cantidad > 0);

    if (productosFormateados.length === 0) {
      setSeleccionados([]);
      setShowSelector(false);
      return;
    }

    setForm({
      ...form,
      productos: [...form.productos, ...productosFormateados],
    });

    setSeleccionados([]);
    setShowSelector(false); // 👈 se cierra al agregar
  };

  // === Modal de confirmación ===
  const [confirmarEliminar, setConfirmarEliminar] = useState(null);

  // === Estado para buscador y paginación de modal de devoluciones ===
  const [busquedaDevolucion, setBusquedaDevolucion] = useState("");
  const [paginaDevolucion, setPaginaDevolucion] = useState(1);
  const devolucionesPorPagina = 6;

  // 🔍 Filtra los despachos confirmados
  const filteredDevoluciones = confirmados.filter((d) => {
    const q = busquedaDevolucion.toLowerCase();
    return (
      d.codigo?.toLowerCase().includes(q) ||
      d.guia?.toLowerCase().includes(q) ||
      d.cliente?.toLowerCase().includes(q) ||
      d.ciudad?.toLowerCase().includes(q)
    );
  });

  // 📄 Paginación
  const totalPaginasDevolucion = Math.ceil(filteredDevoluciones.length / devolucionesPorPagina);
  const startIdx = (paginaDevolucion - 1) * devolucionesPorPagina;
  const endIdx = startIdx + devolucionesPorPagina;
  const paginatedDevoluciones = filteredDevoluciones.slice(startIdx, endIdx);

  const reenviarBonos =
    async (despachoId) => {

      try {

        await axios.post(

          `${process.env.REACT_APP_API_DESPACHOS}/${despachoId}/reenviar-bonos`
        );

        toast.success(
          "Bonos reenviados"
        );

      } catch (err) {

        console.error(err);

        toast.error(
          "Error reenviando bonos"
        );
      }
    };

  const asignarBonos = async (id) => {

    // evitar doble clic
    if (asignandoBonos) return;

    try {

      setAsignandoBonos(true);

      console.log("🚀 Asignando bonos...", id);

      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${API}/${id}/asignar-bonos`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("✅ RESPUESTA:", res.data);

      toast.success(
        "Bonos asignados correctamente"
      );

      // =====================================
      // ACTUALIZAR TABLA
      // =====================================

      setConfirmados((prev) =>
        prev.map((d) =>
          d._id === id
            ? res.data.despacho
            : d
        )
      );

      // =====================================
      // ACTUALIZAR MODAL ABIERTO
      // =====================================

      setDetalleDespacho(
        res.data.despacho
      );

    } catch (err) {

      console.error(
        "❌ ERROR:",
        err.response?.data || err.message
      );

      toast.error(
        err.response?.data?.error ||
        "Error asignando bonos"
      );

    } finally {

      setAsignandoBonos(false);
    }
  };

  const actualizarEstado =
    async (
      despachoId,
      data
    ) => {

      try {

        const res = await axios.put(
          `${process.env.REACT_APP_API_DESPACHOS}/${despachoId}`,
          data
        );

        setConfirmados((prev) =>
          prev.map((d) =>
            d._id === despachoId
              ? res.data
              : d
          )
        );

        // actualizar modal abierto
        if (
          detalleDespacho?._id === despachoId
        ) {
          setDetalleDespacho(
            res.data
          );
        }

        toast.success(
          "Orden actualizada"
        );

      } catch (err) {

        console.error(err);

        toast.error(
          "Error actualizando orden"
        );
      }
    };

  const cerrarDetalle = () => {

    setShowDetalle(false);

    setDetalleDespacho(null);

    setTransportadoraInput("");
    setGuiaInput("");
    setValorEnvioInput("");

  };

  const estadoDetalle =
    (detalleDespacho?.estado || "").toLowerCase();

  const esDevuelto =
    estadoDetalle === "devuelto";



  return (

    <>

    <PageTitle title="Despachos" />

    <div className="desp-root">
      {/* === HEADER === */}
      <header className="desp-header">
        <h2>
          | Centro de Despachos
        </h2>
 
        <div className="desp-btn-column">
          <button
            className="inv-btn-secondary"
            onClick={() => {
              setGuiaInput("");
              setShowGuiaModal(true);
            }}
          >
            <FiTruck size={15} /> Crear orden
          </button>

          <button
            className="inv-btn-secondary"
            onClick={() => {
              if (confirmados.length === 0) return toast.warn("No hay ordenes confirmados para devolver.");
              setShowDevolucion(true);
              setDevolucionSeleccion(null);
            }}
          >
            <FiRepeat size={15} /> Devoluciones
          </button>

          <button className="inv-btn-secondary" onClick={exportarExcel}>
            <FiDownload size={15} /> Descargar reporte
          </button>

          {envios.length > 0 && (

            <button
              className="desp-btn-tertiary"
              disabled={confirmandoEnvios}
              onClick={async () => {

                if (confirmandoEnvios) return;

                try {

                  setConfirmandoEnvios(true);

                  await confirmarEnvios();

                } catch (error) {

                  console.error(error);

                } finally {

                  setConfirmandoEnvios(false);
                }
              }}
            >
              <FiCheckCircle size={15} />

              {confirmandoEnvios
                ? "Confirmando..."
                : "Confirmar orden"}

            </button>

          )}

        </div>
      </header>

      {/* =========================================
          RESUMEN GENERAL
      ========================================= */}

      <div className="desp-resumen-vertical">

        {(() => {

          const lista = confirmados || [];

          const pendientes = lista.filter((d) =>
            ![
              "completado",
              "entregado_digital",
              "despachado",
              "devolucion_parcial",
              "devuelto",
              "legalizado",
            ].includes((d.estado || "").toLowerCase())
          ).length;

          return (
            <p className="desp-frase">

              Actualmente tienes{" "}

              <strong>
                {pendientes}
              </strong>

              {" "}ordenes pendientes por gestionar.

            </p>
          );

        })()}

        <div className="desp-resumen">

          {(() => {

            const lista = confirmados || [];

            const fisicosPendientes = lista.filter((d) =>
              d.tipoDespacho === "fisico" &&
              ![
                "completado",
                "despachado",
                "devolucion_parcial",
                "devuelto",
                "legalizado",
              ].includes((d.estado || "").toLowerCase())
            ).length;

            const digitalesPendientes = lista.filter((d) =>
              d.tipoDespacho === "digital" &&
              ![
                "entregado_digital",
                "completado",
                "devolucion_parcial",
                "devuelto",
              ].includes((d.estado || "").toLowerCase())
            ).length;

            const serviciosPendientes = lista.filter((d) =>
              d.tipoDespacho === "servicio" &&
              ![
                "completado",
                "devolucion_parcial",
                "devuelto",
              ].includes((d.estado || "").toLowerCase())
            ).length;

            return (
              <>

                <div
                  className={`resumen-card ${filtroResumen === "fisico"
                    ? "resumen-card-active"
                    : ""
                    }`}
                  onClick={() =>
                    setFiltroResumen(
                      filtroResumen === "fisico"
                        ? ""
                        : "fisico"
                    )
                  }
                >
                  <h4>Físicos</h4>

                  <p>{fisicosPendientes}</p>
                </div>

                <div
                  className={`resumen-card ${filtroResumen === "digital"
                    ? "resumen-card-active"
                    : ""
                    }`}
                  onClick={() =>
                    setFiltroResumen(
                      filtroResumen === "digital"
                        ? ""
                        : "digital"
                    )
                  }
                >
                  <h4>Digital</h4>

                  <p>{digitalesPendientes}</p>

                </div>

                <div
                  className={`resumen-card ${filtroResumen === "servicio"
                    ? "resumen-card-active"
                    : ""
                    }`}
                  onClick={() =>
                    setFiltroResumen(
                      filtroResumen === "servicio"
                        ? ""
                        : "servicio"
                    )
                  }
                >
                  <h4>Servicio</h4>

                  <p>{serviciosPendientes}</p>

                </div>

              </>
            );

          })()}

        </div>

      </div>


      {/* === CAMIÓN === */}
      <div className="desp-camion-container">
        <img src={truckImage} alt="Camión" className="desp-camion-img" />

        <div className="desp-camion-cargas">
          {envios.map((envio) => (
            <div
              key={envio.id}
              className="desp-caja"
              onClick={() => {
                setForm(envio);
                setEditando(true);
                setShowModal(true);
              }}
            >
              <span
                className="delete-icon"
                title="Eliminar orden"
                onClick={(e) => {
                  e.stopPropagation(); // evita abrir el modal al eliminar
                  setConfirmarEliminar(envio);
                }}
              >
                ×
              </span>

              <p className="desp-caja-id">{envio.identificacion}</p>
              <p className="desp-caja-cliente">{envio.cliente}</p>
            </div>
          ))}
        </div>
      </div>

      {/* === FILTROS === */}
      <div className="inv-filters">
        <div className="inv-row">
          <div className="desp-field">
            <FiSearch className="inv-icon" />
            <input
              placeholder="Buscar por orden, guía, cliente o identificación..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          </div>
          <select
            value={filtroTipo}
            onChange={(e) =>
              setFiltroTipo(e.target.value)
            }
          >
            <option value="">
              Todos los tipos
            </option>

            <option value="fisico">
              Físico
            </option>

            <option value="digital">
              Digital
            </option>

            <option value="servicio">
              Servicio
            </option>
          </select>

          <select
            value={filtroCategoria}
            onChange={(e) => setFiltroCategoria(e.target.value)}
          >
            <option value="">
              Todas las categorías
            </option>

            <option value="venta">
              Venta
            </option>

            <option value="beneficio">
              Beneficio
            </option>
          </select>

          <select
            value={filtroEstadoTabla}
            onChange={(e) =>
              setFiltroEstadoTabla(e.target.value)
            }
          >
            <option value="">
              Todos los estados
            </option>

            <option value="creado">
              Creado
            </option>

            <option value="despachado">
              Despachado
            </option>

            <option value="devolucion_parcial">
              Devolución parcial
            </option>

            <option value="devuelto">
              Devuelto
            </option>

            <option value="en espera">
              En espera
            </option>

            <option value="legalizado">
              Legalizado
            </option>
          </select>

          <div className="desp-date-range">

            <input
              className="desp-date-input"
              type="date"
              value={fechaDesde}
              onChange={(e) =>
                setFechaDesde(e.target.value)
              }
            />

            <input
              className="desp-date-input"
              type="date"
              value={fechaHasta}
              onChange={(e) =>
                setFechaHasta(e.target.value)
              }
            />

          </div>

          <button
            className="inv-btn-ghost"
            onClick={() => {

              setBusqueda("");
              setFiltroTipo("");
              setFiltroCategoria("");
              setFiltroDestino("");
              setFiltroEstadoTabla("");
              setFechaDesde("");
              setFechaHasta("");

            }}
          >
            Restablecer
          </button>
        </div>
      </div>

      {/* === TABLA DE ENVÍOS CONFIRMADOS === */}
      <div className="desp-table">
        <div className="despachos-page">
          <table>
            <thead>
              <tr>

                <th>Orden</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Categoría</th>
                <th>Guía</th>
                <th>Identificación</th>
                <th>Cliente</th>
                <th>Celular</th>
                <th>Destino</th>
                <th>Producto</th>
                <th>Total</th>
                <th>Estado</th>
                <th>Fecha completado</th>
                <th>Acciones</th>

              </tr>
            </thead>
            <tbody>
              {currentPageItems.length > 0 ? (
                currentPageItems.map((envio) => (
                  <tr key={envio._id || envio.id}>

                    <td>
                      {envio.wooOrderId || envio.codigo}
                    </td>

                    <td>
                      {new Date(
                        envio.createdAt || envio.fecha
                      ).toLocaleDateString("es-CO")}
                    </td>

                    <td>
                      <span
                        className={`tipo-chip ${envio.tipoDespacho}`}
                      >
                        {envio.tipoDespacho}
                      </span>
                    </td>

                    <td>
                      {envio.esBeneficio ? "Beneficio" : "Venta"}
                    </td>

                    <td>
                      {[envio.transportadora, envio.guia]
                        .filter(Boolean)
                        .join(" - ") || "-"}
                    </td>

                    <td>
                      {envio.identificacion || "-"}
                    </td>

                    <td>
                      {toTitleCase(envio.cliente) || "-"}
                    </td>

                    <td>
                      {envio.celular || "-"}
                    </td>

                    <td>
                      {envio.tipoDespacho === "digital"
                        ? "Digital"
                        : envio.tipoDespacho === "servicio"
                          ? "Servicio"
                          : toTitleCase(envio.ciudad || "-")}
                    </td>

                    <td>
                      {(() => {
                        const productos =
                          envio.productos
                            ?.map((p) => p.nombre)
                            .join(", ") || "-";

                        return productos.length > 20
                          ? `${productos.substring(0, 20)}...`
                          : productos;
                      })()}
                    </td>

                    <td>
                      $
                      {Number(
                        envio.total || 0
                      ).toLocaleString("es-CO")}
                    </td>

                    <td>
                      {(() => {

                        const estado =
                          (envio.estado || "").toLowerCase();

                        let label = "En espera";
                        let clase = "estado-espera";

                        // Woo pendiente guía
                        if (estado === "pendiente_guia") {
                          label = "En espera";
                          clase = "estado-espera";
                        }

                        // Creado internamente
                        if (estado === "creado") {
                          label = "Creado";
                          clase = "estado-creado";
                        }

                        // Completados
                        if (
                          [
                            "entregado_digital",
                            "completado",
                            "despachado",
                          ].includes(estado)
                        ) {
                          label = "Despachado";
                          clase = "estado-despachado";
                        }

                        if (estado === "devolucion_parcial") {
                          label = "Devolución parcial";
                          clase = "estado-devolucion";
                        }

                        if (estado === "devuelto") {
                          label = "Devuelto";
                          clase = "estado-devuelto";
                        }

                        // =========================
                        // COMPLETADOS
                        // =========================

                        if (
                          [
                            "entregado_digital",
                            "completado",
                            "despachado",
                          ].includes(estado)
                        ) {

                          label = "Despachado";
                          clase = "estado-despachado";
                        }

                        // =========================
                        // DEVOLUCIÓN PARCIAL
                        // =========================

                        if (estado === "devolucion_parcial") {

                          label = "Devolución parcial";
                          clase = "estado-devolucion";
                        }

                        // =========================
                        // DEVUELTO COMPLETO
                        // =========================

                        if (estado === "devuelto") {

                          label = "Devuelto";
                          clase = "estado-devuelto";
                        }

                        if (estado === "legalizado") {

                          label = "Legalizado";
                          clase = "estado-legalizado";
                        }

                        return (
                          <span className={`estado-chip ${clase}`}>
                            {label}
                          </span>
                        );

                      })()}
                    </td>

                    <td>
                      {envio.fechaCompletado
                        ? new Date(
                          envio.fechaCompletado
                        ).toLocaleDateString("es-CO")
                        : "-"}
                    </td>

                    <td>
                      <button
                        className="inv-icon-btn"
                        onClick={() => {

                          setDetalleDespacho(envio);

                          setTransportadoraInput(
                            envio.transportadora || ""
                          );

                          setGuiaInput(
                            envio.guia || ""
                          );

                          setShowDetalle(true);
                        }}
                      >
                        <FiEye />
                      </button>
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="13"
                    style={{
                      textAlign: "center",
                      padding: "18px",
                    }}
                  >
                    No hay ordenes confirmadas aún.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* === PAGINACIÓN === */}
          <div className="inv-paginacion">
            <button
              className="inv-btn-paginacion"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Anterior
            </button>
            <span className="inv-pagina-info">
              Página {page} de {totalPages || 1}
            </span>
            <button
              className="inv-btn-paginacion"
              disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage(page + 1)}
            >
              Siguiente
            </button>
          </div>
        </div>

        {/* === MODAL DESPACHO === */}
        {showModal && (
          createPortal(
            <div className="desp-modal-overlay" onClick={() => setShowModal(false)}>
              <div className="desp-modal modal-animate" onClick={(e) => e.stopPropagation()}>

                {/* === CABECERA === */}
                <div className="desp-modal-header">
                  <h3>{editando ? "Modificación de Orden" : "Creación de Orden"}</h3>
                </div>

                {/* === CONTENIDO SCROLLEABLE === */}
                <div className="desp-modal-content">

                  {/* === FORMULARIO === */}
                  <div className="desp-modal-section">
                    <h4>Datos del destinatario</h4>
                    <div className="desp-form">
                      <div className="desp-form-group">
                        <label>Nombres</label>
                        <input
                          type="text"
                          value={form.cliente}
                          onChange={(e) => setForm({ ...form, cliente: e.target.value })}
                        />
                      </div>
                      <div className="desp-form-group">
                        <label>Identificación</label>
                        <input
                          type="number"
                          value={form.identificacion}
                          onChange={(e) => setForm({ ...form, identificacion: e.target.value })}
                        />
                      </div>
                      <div className="desp-form-group">
                        <label htmlFor="celular">Celular</label>
                        <input
                          id="celular"
                          type="tel"
                          inputMode="numeric"
                          pattern="[0-9]{10}"
                          maxLength={10}
                          value={form.celular}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setForm({ ...form, celular: value });
                          }}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* === DATOS DE ENVÍO === */}

                  {form.tipoDespacho === "fisico" && (

                    <div className="desp-modal-section">

                      <h4>
                        Datos de envío
                      </h4>

                      <div className="desp-form">

                        <div className="desp-form-group">

                          <label>
                            Ciudad origen
                          </label>

                          <input
                            value={form.origen}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                origen: e.target.value
                              })
                            }
                          />

                        </div>

                        <div className="desp-form-group">

                          <label>
                            Departamento destino
                          </label>

                          <select
                            value={form.departamento}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                departamento:
                                  e.target.value,
                              })
                            }
                          >

                            <option value="">
                              Seleccionar...
                            </option>

                            {departamentosColombia.map((dep) => (

                              <option
                                key={dep}
                                value={dep}
                              >
                                {dep}
                              </option>

                            ))}

                          </select>

                        </div>

                        <div className="desp-form-group">

                          <label>
                            Ciudad destino
                          </label>

                          <input
                            value={form.ciudad}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                ciudad: e.target.value
                              })
                            }
                          />

                        </div>

                        <div className="desp-form-group">

                          <label>
                            Barrio destino
                          </label>

                          <input
                            value={form.barrio}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                barrio: e.target.value
                              })
                            }
                          />

                        </div>

                        <div className="desp-form-group">

                          <label>
                            Dirección destino
                          </label>

                          <input
                            value={form.direccion}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                direccion: e.target.value
                              })
                            }
                          />

                        </div>

                      </div>

                    </div>

                  )}

                  {/* === BENEFICIOS === */}

                  <div className="desp-modal-section">

                    <h4>Clasificación de la orden</h4>

                    <div className="desp-form">

                      <div className="desp-form-group">

                        <label>¿Es un beneficio?</label>

                        <select
                          value={form.esBeneficio ? "si" : "no"}
                          onChange={(e) =>
                            setForm({
                              ...form,
                              esBeneficio: e.target.value === "si",
                              programaBeneficio:
                                e.target.value === "si"
                                  ? form.programaBeneficio
                                  : "",
                            })
                          }
                        >
                          <option value="no">
                            No
                          </option>

                          <option value="si">
                            Sí
                          </option>

                        </select>

                      </div>

                      {form.esBeneficio && (

                        <div className="desp-form-group">

                          <label>Programa</label>

                          <select
                            value={form.programaBeneficio}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                programaBeneficio:
                                  e.target.value,
                              })
                            }
                          >

                            <option value="">
                              Seleccionar programa...
                            </option>

                            <option value="31169 - Donación Calamidad Asociado">
                              31169 - Donación Calamidad Asociado
                            </option>

                            <option value="30623 - Dotando mi Casa">
                              30623 - Dotando mi Casa
                            </option>

                            <option value="30628 - Historia de Colores">
                              30628 - Historia de Colores
                            </option>

                            <option value="31170 - Kit Escolar">
                              31170 - Kit Escolar
                            </option>

                            <option value="30638 - Obsequio Amor y Amistad">
                              30638 - Obsequio Amor y Amistad
                            </option>

                            <option value="30637 - Obsequio Cumpleaños">
                              30637 - Obsequio Cumpleaños
                            </option>

                            <option value="30635 - Obsequio Grado Asociado">
                              30635 - Obsequio Grado Asociado
                            </option>

                            <option value="30636 - Obsequio Matrimonio">
                              30636 - Obsequio Matrimonio
                            </option>

                            <option value="30634 - Obsequio Nacimiento Hijo Asociado">
                              30634 - Obsequio Nacimiento Hijo Asociado
                            </option>

                            <option value="30639 - Obsequio Navidad">
                              30639 - Obsequio Navidad
                            </option>

                            <option value="31171 - Somos Multiplicadores">
                              31171 - Somos Multiplicadores
                            </option>

                            <option value="30616 - Sorteo Experiencias">
                              30616 - Sorteo Experiencias
                            </option>

                          </select>

                        </div>

                      )}

                    </div>

                  </div>

                  {/* === PRODUCTOS === */}
                  <div className="desp-modal-section">
                    <h4>Productos del envío</h4>
                    <div className="desp-productos-row">

                      <button
                        type="button"
                        className="desp-btn-mini"
                        onClick={() => setShowSelector(true)}
                      >
                        <FiPlus /> Agregar producto
                      </button>

                      <button
                        type="button"
                        className="desp-btn-temporal"
                        onClick={() => setShowTemporalModal(true)}
                      >
                        <FiFileText /> Producto temporal
                      </button>
                    </div>
                  </div>

                  {/* === LISTA DE PRODUCTOS (scroll interno si hay más de 3) === */}
                  <div className="desp-lista-productos">
                    {form.productos.length > 0 ? (
                      form.productos.map((p) => {
                        const prodBase = productosInventario.find((x) => x._id === p._id);
                        const precioUnit =
                          p.tipoPrecio === "coste"
                            ? prodBase?.costPrice ?? 0
                            : prodBase?.salePrice ?? 0;

                        return (
                          <div key={p._id} className="desp-prod-item">
                            {/* Nombre */}
                            <span className="nombre">
                              {p.codigo ? `${p.codigo} - ${p.nombre}` : p.nombre}
                            </span>

                            {/* Controles cantidad */}
                            <div className="cantidad-controls">
                              <button type="button" onClick={() => decCantidad(p._id)}>-</button>
                              <input
                                type="number"
                                min="1"
                                value={p.cantidad}
                                onChange={(e) => setCantidadProducto(p._id, e.target.value)}
                              />
                              <button type="button" onClick={() => incCantidad(p._id)}>+</button>
                              <small className="disp">
                                disp: {getDisponibleAhora(p._id).toLocaleString("es-CO")}
                              </small>
                            </div>

                            {/* Tipo de precio */}
                            <select
                              className="precio-select"
                              value={form.esBeneficio ? "coste" : p.tipoPrecio || "venta"}
                              disabled={form.esBeneficio}
                              onChange={(e) => {
                                const nuevos = form.productos.map((item) =>
                                  item._id === p._id
                                    ? { ...item, tipoPrecio: e.target.value }
                                    : item
                                );
                                setForm({ ...form, productos: nuevos });
                              }}
                            >
                              <option value="coste">Coste</option>
                              <option value="venta">Venta</option>
                            </select>

                            {/* Eliminar */}
                            <button
                              className="btn-eliminar"
                              onClick={() => {
                                const filtrados = form.productos.filter((item) => item._id !== p._id);
                                setForm({ ...form, productos: filtrados });
                              }}
                              title="Eliminar producto"
                            >
                              <FiTrash2 />
                            </button>
                          </div>
                        );
                      })
                    ) : (
                      <p style={{ fontSize: "0.85rem", color: "#777" }}>
                        Aún no has agregado productos al envío.
                      </p>
                    )}
                  </div>
                </div> {/* 🔹 cierre del contenido scrolleable */}

                {/* === BOTONES FIJOS === */}
                <div className="desp-modal-actions">
                  <button className="desp-btn-secondary" onClick={() => setShowModal(false)}>
                    Cancelar
                  </button>
                  <button className="desp-btn-primary" onClick={guardarEnvio}>
                    {editando ? "Modificar orden" : "Crear orden"}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ))}


        {/* === SUBMODAL SELECCIÓN DE PRODUCTOS === */}
        {showSelector && (
          createPortal(
            <div className="desp-modal-overlay" onClick={() => setShowSelector(false)}>
              <div className="desp-modal desp-selector modal-animate" onClick={(e) => e.stopPropagation()}>
                <h3>Bodega Virtual</h3>
                <input
                  type="text"
                  className="bodega-search"
                  placeholder="Buscar producto..."
                  value={busquedaProducto}
                  onChange={(e) =>
                    setBusquedaProducto(e.target.value)
                  }
                />
                <div className="desp-estanteria-grid">
                  {productosInventario.length > 0 ? (
                    productosFiltrados.map((prod) => {
                      const isSelected = seleccionados.includes(prod._id);
                      const disponible = getDisponibleAhora(prod._id);
                      const disabled = disponible <= 0;
                      return (
                        <div
                          key={prod._id}
                          className={`desp-card-prod ${isSelected ? "selected" : ""} ${getDisponibleAhora(prod._id) <= 0 ? "disabled" : ""}`}
                          onClick={() => {
                            const disponible = getDisponibleAhora(prod._id);
                            if (disponible <= 0) return; // ❌ No deja seleccionar sin stock

                            if (isSelected) {
                              setSeleccionados(seleccionados.filter((id) => id !== prod._id));
                            } else {
                              setSeleccionados([...seleccionados, prod._id]);
                            }
                          }}
                          title={getDisponibleAhora(prod._id) <= 0 ? "Sin unidades disponibles" : ""}
                        >
                          <div className="desp-prod-header">
                            <div className="desp-prod-emoji">📦</div>
                          </div>

                          <div className="desp-prod-body">
                            <p className="desp-prod-code">{prod.code}</p>
                            <h4 className="desp-prod-name">{prod.name}</h4>
                            <p className="desp-prod-obs">
                              {prod.notes || "Sin observaciones"}
                            </p>

                            <hr className="desp-prod-divider" />

                            <div className="desp-prod-info">
                              <div><strong>Bodega:</strong> {prod.location || "—"}</div>
                              <div><strong>Estantería:</strong> {prod.shelf || "—"}</div>
                              <div><strong>Stock:</strong> {Number(prod.quantity ?? 0).toLocaleString("es-CO")}</div>
                              <div><strong>Coste:</strong> ${Number(prod.costPrice ?? 0).toLocaleString("es-CO")}</div>
                              <div><strong>Venta:</strong> ${Number(prod.salePrice ?? 0).toLocaleString("es-CO")}</div>
                              <div><strong>DT:</strong> {getDisponibleAhora(prod._id).toLocaleString("es-CO")}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p style={{ textAlign: "center", width: "100%", marginTop: "10px" }}>
                      No hay productos disponibles en inventario.
                    </p>
                  )}
                </div>

                {/* Acciones */}
                <div className="desp-modal-actions">
                  <button
                    className="desp-btn-secondary"
                    onClick={() => setShowSelector(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="desp-btn-primary"
                    onClick={() => agregarSeleccionados()}
                    disabled={seleccionados.length === 0}
                  >
                    Agregar seleccionados
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ))}

        {/* === SUBMODALPRODUCTO TEMPORAL === */}
        {showTemporalModal && (
          createPortal(
            <div className="desp-modal-overlay" onClick={() => setShowTemporalModal(false)}>
              <div className="desp-mini-modal" onClick={(e) => e.stopPropagation()}>
                <h4>Agregar Producto Temporal</h4>

                <div className="mini-form">
                  <label>Nombre del producto</label>
                  <input
                    type="text"
                    value={tempProducto.nombre}
                    onChange={(e) =>
                      setTempProducto({ ...tempProducto, nombre: e.target.value })
                    }
                  />

                  <label>Cantidad</label>
                  <input
                    type="number"
                    min="1"
                    value={tempProducto.cantidad}
                    onChange={(e) =>
                      setTempProducto({
                        ...tempProducto,
                        cantidad: Math.max(1, Number(e.target.value)),
                      })
                    }
                  />

                  <label>Valor unitario</label>
                  <input
                    type="number"
                    min="0"
                    value={tempProducto.valorManual}
                    onChange={(e) =>
                      setTempProducto({
                        ...tempProducto,
                        tipoPrecio: "manual", // 👈 siempre fijo a "manual"
                        valorManual: e.target.value,
                      })
                    }
                    placeholder="Ej: 25000"
                  />
                </div>

                <div className="mini-actions">
                  <button
                    className="desp-btn-secondary"
                    onClick={() => setShowTemporalModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="desp-btn-primary"
                    onClick={() => {
                      if (!tempProducto.nombre.trim()) return toast.warn("Escribe un nombre.");

                      const nuevoTemp = {
                        codigo: "TMP" + Math.floor(Math.random() * 9999),
                        nombre: tempProducto.nombre,
                        cantidad: tempProducto.cantidad,
                        tipoPrecio: "manual", // 🔹 en minúsculas (válido para Mongoose)
                        valorManual: Number(tempProducto.valorManual) || 0,
                        costPrice: 0,
                        salePrice: 0,
                        temporal: true, // marcador
                        stock: tempProducto.cantidad,
                      };

                      // ✅ Agregar producto temporal a la lista actual
                      setForm((prev) => ({
                        ...prev,
                        productos: [...(prev.productos || []), nuevoTemp],
                      }));

                      setShowTemporalModal(false);
                      setTempProducto({
                        nombre: "",
                        cantidad: 1,
                        tipoPrecio: "manual",
                        valorManual: "",
                      });
                    }}
                  >
                    Agregar temporal
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        )}

        {/* === MODAL SELECCIONAR DESPACHO PARA DEVOLUCIÓN === */}
        {showDevolucion && !devolucionSeleccion && (
          createPortal(
            <div
              className="desp-modal-overlay"
              onClick={() => setShowDevolucion(false)}
            >
              <div
                className="devolucion-modal devolucion-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="devolucion-header centered">
                  <h3>Devolución de Ordenes</h3>
                </div>

                {/* 🔍 BUSCADOR */}
                <div className="devolucion-search">
                  <FiSearch className="devolucion-search-icon" />
                  <input
                    type="text"
                    placeholder="Buscar orden..."
                    value={busquedaDevolucion}
                    onChange={(e) => {
                      setBusquedaDevolucion(e.target.value);
                      setPaginaDevolucion(1);
                    }}
                  />
                </div>

                {/* 📋 TABLA DE DESPACHOS */}
                <div className="devolucion-body">
                  {paginatedDevoluciones.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Orden</th>
                          <th>Fecha</th>
                          <th>Guía</th>
                          <th>Tipo</th>
                          <th>Categoría</th>
                          <th>Identificación</th>
                          <th>Cliente</th>
                          <th>Ciudad destino</th>
                          <th>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedDevoluciones.map((d) => (
                          <tr key={d._id}>
                            <td>{d.wooOrderId ? `#${d.wooOrderId}` : d.codigo} </td>
                            <td>
                              {d.fecha
                                ? new Date(d.fecha).toLocaleDateString("es-CO")
                                : "—"}
                            </td>
                            <td>{d.guia || "—"}</td>
                            <td>
                              {d.tipoDespacho?.charAt(0).toUpperCase() +
                                d.tipoDespacho?.slice(1)}
                            </td>
                            <td>
                              {d.esBeneficio ? "Beneficio" : "Venta"}
                            </td>
                            <td>{d.identificacion || "—"}</td>
                            <td>{d.cliente}</td>
                            <td>{d.ciudad}</td>
                            <td>
                              <button
                                className="inv-icon-btn"
                                title="Registrar devolución"
                                onClick={() => setDevolucionSeleccion(d)}
                              >
                                <FiRepeat />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p className="devolucion-empty">No hay resultados para tu búsqueda.</p>
                  )}
                </div>

                {/* 📄 PAGINACIÓN */}
                {filteredDevoluciones.length > devolucionesPorPagina && (
                  <div className="devolucion-paginacion">
                    <button
                      className="devolucion-btn-paginacion"
                      disabled={paginaDevolucion === 1}
                      onClick={() => setPaginaDevolucion((p) => Math.max(1, p - 1))}
                    >
                      Anterior
                    </button>
                    <span className="devolucion-pagina-info">
                      Página {paginaDevolucion} de {totalPaginasDevolucion}
                    </span>
                    <button
                      className="devolucion-btn-paginacion"
                      disabled={paginaDevolucion === totalPaginasDevolucion}
                      onClick={() =>
                        setPaginaDevolucion((p) =>
                          Math.min(totalPaginasDevolucion, p + 1)
                        )
                      }
                    >
                      Siguiente
                    </button>
                  </div>
                )}

                {/* 🔘 BOTONES */}
                <div className="devolucion-actions">
                  <button
                    className="devolucion-btn-secondary"
                    onClick={() => setShowDevolucion(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        )}

        {/* === MODAL DE DEVOLUCIONES === */}
        {showDevolucion && devolucionSeleccion && (() => {

          // =========================================
          // VALIDAR SI AÚN HAY PRODUCTOS PENDIENTES
          // =========================================

          const tienePendientesDevolucion =
            devolucionSeleccion.productos?.some((p) => {

              const yaDevuelto =
                devolucionSeleccion.devueltos
                  ?.filter(
                    (d) =>
                      String(d.productoId) ===
                      String(p._id)
                  )
                  .reduce(
                    (acc, d) =>
                      acc + Number(d.cantidad || 0),
                    0
                  ) || 0;

              const disponible =
                Number(p.cantidad || 0) - yaDevuelto;

              return disponible > 0;
            });

          return createPortal(

            <div
              className="desp-modal-overlay"
              onClick={() => {
                setShowDevolucion(false);
                setDevolucionSeleccion(null);
              }}
            >

              <div
                className="devolucion-modal"
                onClick={(e) => e.stopPropagation()}
              >

                <div className="devolucion-header">

                  <h3>
                    Registro de Devolución
                  </h3>

                  <small>

                    Orden:

                    <strong>

                      {
                        devolucionSeleccion.wooOrderId
                          ? ` #${devolucionSeleccion.wooOrderId}`
                          : ` ${devolucionSeleccion.codigo}`
                      }

                    </strong>

                    {" — "}

                    {devolucionSeleccion.cliente}

                  </small>

                </div>

                <div className="devolucion-body">

                  {devolucionSeleccion.productos?.length > 0 ? (

                    <table>

                      <thead>

                        <tr>
                          <th>SKU</th>
                          <th>Producto</th>
                          <th>Cantidad enviada</th>
                          <th>Cantidad devolución</th>
                        </tr>

                      </thead>

                      <tbody>

                        {devolucionSeleccion.productos.map((p, i) => {

                          const key = p._id || i;

                          // =========================================
                          // YA DEVUELTO
                          // =========================================

                          const yaDevuelto =
                            devolucionSeleccion.devueltos
                              ?.filter(
                                (d) =>
                                  String(d.productoId) ===
                                  String(p._id)
                              )
                              .reduce(
                                (acc, d) =>
                                  acc + Number(d.cantidad || 0),
                                0
                              ) || 0;

                          // =========================================
                          // DISPONIBLE
                          // =========================================

                          const disponible =
                            Math.max(
                              Number(p.cantidad || 0) - yaDevuelto,
                              0
                            );

                          const valorActual =
                            devolucionesMap[key] || 0;

                          return (

                            <tr key={key}>

                              {/* CÓDIGO */}
                              <td>
                                {p.codigo}
                              </td>

                              {/* PRODUCTO */}
                              <td>
                                {p.nombre}
                              </td>

                              {/* CANTIDAD ENVIADA */}
                              <td>
                                {p.cantidad}
                              </td>

                              {/* DEVOLUCIÓN */}
                              <td>

                                {disponible <= 0 ? (

                                  <span
                                    style={{
                                      color: "#999",
                                      fontWeight: 600
                                    }}
                                  >
                                    Devuelto completamente
                                  </span>

                                ) : (

                                  <input
                                    type="number"
                                    min="0"
                                    max={disponible}
                                    value={valorActual}
                                    onChange={(e) => {

                                      let value =
                                        Number(e.target.value);

                                      if (value > disponible)
                                        value = disponible;

                                      if (value < 0)
                                        value = 0;

                                      setDevolucionesMap({
                                        ...devolucionesMap,
                                        [key]: value,
                                      });
                                    }}
                                    style={{
                                      width: "80px",
                                      textAlign: "center"
                                    }}
                                  />

                                )}

                                {/* YA DEVUELTO */}
                                {yaDevuelto > 0 && (

                                  <div
                                    style={{
                                      fontSize: "11px",
                                      color: "#888",
                                      marginTop: "4px"
                                    }}
                                  >
                                    Ya devuelto: {yaDevuelto}
                                  </div>

                                )}

                              </td>

                            </tr>
                          );
                        })}

                      </tbody>

                    </table>

                  ) : (

                    <p className="devolucion-empty">
                      Esta orden no tiene productos registrados.
                    </p>

                  )}

                </div>

                <div className="devolucion-actions">

                  {/* ATRÁS */}
                  <button
                    className="devolucion-btn-secondary"
                    onClick={() => {
                      setDevolucionSeleccion(null);
                      setDevolucionesMap({});
                    }}
                  >
                    Atrás
                  </button>

                  {/* BOTÓN SOLO SI AÚN HAY DEVOLUCIONES */}
                  {tienePendientesDevolucion && (

                    <button
                      className="devolucion-btn-primary"
                      disabled={loadingDevolucion}
                      style={{
                        opacity:
                          loadingDevolucion ? 0.7 : 1,

                        cursor:
                          loadingDevolucion
                            ? "not-allowed"
                            : "pointer"
                      }}

                      onClick={async () => {

                        try {

                          setLoadingDevolucion(true);

                          const devoluciones =
                            Object.entries(devolucionesMap)

                              .filter(
                                ([_, cant]) => cant > 0
                              )

                              .map(([key, cantidad]) => {

                                const prod =
                                  devolucionSeleccion.productos.find(
                                    (p) =>
                                      p._id?.toString() === key ||
                                      p._id === key
                                  );

                                return {
                                  productoId: prod?._id,
                                  cantidad,
                                  fecha: new Date(),
                                };
                              });

                          if (devoluciones.length === 0) {

                            toast.warn(
                              "No seleccionaste ninguna cantidad a devolver."
                            );

                            return;
                          }

                          await axios.put(

                            `${process.env.REACT_APP_API_DESPACHOS}/${devolucionSeleccion._id}/devolver`,

                            { devoluciones }
                          );

                          toast.success(
                            "Devolución registrada con éxito."
                          );

                          // =========================================
                          // RECARGAR DESPACHOS
                          // =========================================

                          const token = localStorage.getItem("token");

                          const res = await axios.get(
                            process.env.REACT_APP_API_DESPACHOS,
                            {
                              headers: {
                                Authorization: `Bearer ${token}`,
                              },
                            }
                          );

                          setConfirmados(res.data || []);

                          // =========================================
                          // ACTUALIZAR MODAL ACTUAL
                          // =========================================

                          const actualizado =
                            res.data.find(
                              (d) =>
                                d._id ===
                                devolucionSeleccion._id
                            );

                          if (actualizado) {

                            setDevolucionSeleccion(
                              actualizado
                            );

                          } else {

                            setShowDevolucion(false);

                            setDevolucionSeleccion(null);
                          }

                          setDevolucionesMap({});

                        } catch (err) {

                          console.error(
                            "❌ Error al devolver productos:",
                            err
                          );

                          toast.error(
                            "Error al procesar la devolución."
                          );

                        } finally {

                          setLoadingDevolucion(false);
                        }
                      }}
                    >

                      {
                        loadingDevolucion
                          ? "Procesando..."
                          : "Confirmar devolución"
                      }

                    </button>

                  )}

                </div>

              </div>

            </div>,
            document.body

          );

        })()}

        {confirmarEliminar && (
          <div className="desp-modal-overlay" onClick={() => setConfirmarEliminar(null)}>
            <div
              className="desp-mini-modal confirm-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h4>¿Eliminar orden?</h4>
              <p>
                ¿Seguro deseas eliminar la orden de <strong>{confirmarEliminar.cliente}</strong>?
              </p>
              <div className="mini-actions">
                <button
                  className="desp-btn-secondary"
                  onClick={() => setConfirmarEliminar(null)}
                >
                  Cancelar
                </button>
                <button
                  className="desp-btn-primary"
                  onClick={() => {
                    setEnvios(envios.filter((x) => x.id !== confirmarEliminar.id));
                    toast.info("Orden eliminada con éxito.");
                    setConfirmarEliminar(null);
                  }}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        )}

        {showGuiaModal &&
          createPortal(
            <div
              className="desp-modal-overlay"
              onClick={() => setShowGuiaModal(false)}
            >
              <div
                className="desp-mini-modal"
                onClick={(e) => e.stopPropagation()}

              >

                <h4>
                  Tipo de Orden
                </h4>

                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#666"
                  }}
                >
                  Selecciona el tipo de orden que deseas crear.
                </p>

                {/* ===================================== */}
                {/* TIPO */}
                {/* ===================================== */}

                <div className="mini-form">

                  <label>
                    Tipo de orden
                  </label>

                  <select
                    value={tipoDespachoActual}
                    onChange={(e) =>
                      setTipoDespachoActual(
                        e.target.value
                      )
                    }
                  >

                    <option value="">
                      Seleccionar...
                    </option>

                    <option value="fisico">
                      Físico
                    </option>

                    <option value="digital">
                      Digital
                    </option>

                    <option value="servicio">
                      Servicio
                    </option>

                  </select>

                </div>


                {/* ===================================== */}
                {/* ACCIONES */}
                {/* ===================================== */}

                <div className="mini-actions">

                  <button
                    className="desp-btn-secondary"
                    onClick={() => {

                      setShowGuiaModal(false);
                      setTipoDespachoActual("");
                      setGuiaInput("");

                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    className="desp-btn-primary"
                    onClick={() => {

                      if (!tipoDespachoActual) {

                        return toast.warn(
                          "Selecciona un tipo de orden."
                        );
                      }

                      // =====================================
                      // SETEAR DATOS
                      // =====================================

                      setGuiaActual("");

                      setForm((prev) => ({
                        ...prev,
                        tipoDespacho:
                          tipoDespachoActual,
                      }));

                      setShowGuiaModal(false);

                      openModal();

                    }}
                  >
                    Continuar
                  </button>

                </div>

              </div>



            </div>,

            document.body

          )

        }

        {showDetalle && detalleDespacho && (
          createPortal(
            <div
              className="desp-modal-overlay"
              onClick={cerrarDetalle}
            >
              <div
                className="g360-detalle-modal"
                onClick={(e) => e.stopPropagation()}
              >

                {/* HEADER */}

                <div className="g360-detalle-header">

                  <div className="g360-detalle-header-content">

                    <h2>
                      Orden #
                      {detalleDespacho.wooOrderId || detalleDespacho.codigo}
                    </h2>

                    <p>
                      Creado el{" "}
                      {new Date(
                        detalleDespacho.createdAt || detalleDespacho.fecha
                      ).toLocaleString("es-CO")}
                    </p>

                  </div>

                  <button
                    className="g360-header-icon-btn"
                    onClick={imprimirRotulo}
                    title="Imprimir rótulo"
                  >
                    <FiPrinter size={18} />
                  </button>

                </div>


                {/* KPIS */}

                <div className="g360-kpis-grid">

                  <div className="g360-kpi">
                    <span>Estado</span>

                    {(() => {

                      const estado =
                        (detalleDespacho.estado || "").toLowerCase();

                      let label = "En espera";

                      if (["creado"].includes(estado)) {
                        label = "Creado";
                      }

                      if (
                        [
                          "completado",
                          "entregado_digital",
                          "despachado",
                        ].includes(estado)
                      ) {
                        label = "Despachado";
                      }

                      if (estado === "devolucion_parcial") {
                        label = "Devolución parcial";
                      }

                      if (estado === "devuelto") {
                        label = "Devuelto";
                      }

                      if (estado === "legalizado") {
                        label = "Legalizado";
                      }

                      let detalle = "Pendiente confirmar entrega";

                      // FÍSICO
                      if (detalleDespacho.tipoDespacho === "fisico") {

                        detalle =
                          detalleDespacho.guia &&
                            detalleDespacho.transportadora
                            ? `${detalleDespacho.transportadora} · ${detalleDespacho.guia}`
                            : "Pendiente confirmar entrega";
                      }

                      // DIGITAL
                      if (detalleDespacho.tipoDespacho === "digital") {

                        detalle =
                          estado === "completado" ||
                            estado === "entregado_digital"
                            ? "Bonos enviados"
                            : "Pendiente de asignación";
                      }

                      // SERVICIO
                      if (detalleDespacho.tipoDespacho === "servicio") {

                        detalle =
                          estado === "completado"
                            ? "Proveedor notificado"
                            : "Pendiente notificar proveedor";
                      }

                      return (
                        <>
                          <strong>{label}</strong>

                          <small>
                            {detalle}
                          </small>
                        </>
                      );

                    })()}
                  </div>

                  <div className="g360-kpi">
                    <span>Tipo</span>

                    <strong>
                      {detalleDespacho.tipoDespacho?.charAt(0).toUpperCase() +
                        detalleDespacho.tipoDespacho?.slice(1)}
                      {" · "}
                      {detalleDespacho.esBeneficio
                        ? "Beneficio"
                        : "Venta"}
                    </strong>

                    <small>
                      {detalleDespacho.esBeneficio
                        ? (
                          detalleDespacho.programaBeneficio?.includes(" - ")
                            ? detalleDespacho.programaBeneficio.split(" - ")[1]
                            : detalleDespacho.programaBeneficio
                        )
                        : detalleDespacho.origenPedido === "woocommerce"
                          ? "Creado desde Kómpralo"
                          : "Creado desde G360"}
                    </small>
                  </div>

                  <div className="g360-kpi">
                    <span>Total</span>

                    <strong>
                      $
                      {(
                        Number(detalleDespacho.total || 0) +
                        Number(detalleDespacho.valorEnvio || 0)
                      ).toLocaleString("es-CO")}
                    </strong>

                    <small>
                      Artículos $
                      {Number(
                        detalleDespacho.total || 0
                      ).toLocaleString("es-CO")}

                      {Number(detalleDespacho.valorEnvio || 0) > 0 &&
                        ` · Envío $${Number(
                          detalleDespacho.valorEnvio || 0
                        ).toLocaleString("es-CO")}`}
                    </small>
                  </div>

                  <div className="g360-kpi">
                    <span>Fecha completado</span>

                    <strong>
                      {detalleDespacho.fechaCompletado
                        ? new Date(
                          detalleDespacho.fechaCompletado
                        ).toLocaleString("es-CO")
                        : "Pendiente"}
                    </strong>
                  </div>


                </div>

                {/* CLIENTE */}

                <div className="dx-section">

                  <div className="dx-section-title">
                    <h3>Datos del cliente</h3>
                  </div>

                  <div className="dx-line-card">

                    <div className="dx-line-item">
                      <span>Identificación</span>
                      <strong>{detalleDespacho.identificacion || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Nombre</span>
                      <strong>{toTitleCase(detalleDespacho.cliente) || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Celular</span>
                      <strong>{detalleDespacho.celular || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Email</span>
                      <strong>{detalleDespacho.email || "—"}</strong>
                    </div>

                  </div>

                </div>

                {/* DESTINO */}

                <div className="dx-section">

                  <div className="dx-section-title">

                    <h3>Destino</h3>

                    {[
                      "creado",
                      "pendiente_guia",
                      "pendiente_proveedor",
                    ].includes(
                      (detalleDespacho.estado || "").toLowerCase()
                    ) && (

                        <button
                          type="button"
                          className="dx-edit-btn"
                          onClick={() => {

                            setDireccionEdit({
                              departamento:
                                detalleDespacho.departamento || "",

                              ciudad:
                                detalleDespacho.ciudad || "",

                              barrio:
                                detalleDespacho.barrio || "",

                              direccion:
                                detalleDespacho.direccion || "",
                            });

                            setShowEditarDireccion(true);

                          }}
                        >
                          <FiEdit2 />
                        </button>

                      )}

                  </div>

                  <div className="dx-line-card">

                    <div className="dx-line-item">
                      <span>Departamento</span>
                      <strong>{detalleDespacho.departamento || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Ciudad</span>
                      <strong>{toTitleCase(detalleDespacho.ciudad) || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Barrio</span>
                      <strong>{toTitleCase(detalleDespacho.barrio) || "—"}</strong>
                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">
                      <span>Dirección</span>
                      <strong>{toTitleCase(detalleDespacho.direccion) || "—"}</strong>
                    </div>

                  </div>

                </div>

                {/* PRODUCTOS */}

                <div className="g360-section">

                  <div className="dx-section-title">
                    <h3>Productos</h3>
                  </div>

                  <div className="g360-products-wrap">

                    {detalleDespacho.productos?.map((p, i) => {

                      const precio =
                        p.tipoPrecio === "manual"
                          ? Number(p.valorManual || 0)
                          : p.tipoPrecio === "coste"
                            ? Number(p.costPrice || 0)
                            : Number(p.salePrice || 0);

                      return (

                        <div
                          key={i}
                          className="g360-product-row"
                        >

                          <div className="g360-product-left">

                            <div>
                              <small>SKU</small>
                              <h4>{p.codigo || "—"}</h4>
                            </div>

                            <div className="g360-divider" />

                            <div>
                              <small>Producto</small>
                              <p>{p.nombre}</p>
                            </div>

                          </div>

                          <div className="g360-product-right">

                            <div className="g360-qty">
                              x{p.cantidad}
                            </div>

                            <div className="g360-price">
                              $
                              {precio.toLocaleString("es-CO")}
                            </div>

                          </div>

                        </div>
                      );
                    })}

                  </div>

                </div>

                {/* ENVÍO */}

                {detalleDespacho.tipoDespacho === "fisico" &&
                  [
                    "creado",
                    "pendiente_guia"
                  ].includes(
                    (detalleDespacho.estado || "").toLowerCase()
                  ) && (

                    <div className="dx-section">

                      <div
                        className={`dx-section-title dx-accordion-header ${openEnvio ? "active" : "closed"
                          }`}
                        onClick={() => setOpenEnvio(!openEnvio)}
                      >
                        <h3>
                          Envío
                        </h3>

                        <span
                          className={`dx-accordion-icon ${openEnvio ? "open" : ""
                            }`}
                        >
                          ▾
                        </span>

                      </div>

                      <div
                        className={`dx-accordion-content ${openEnvio ? "open" : ""
                          }`}
                      >
                        <div className="dx-line-card">

                          <div className="dx-line-item">

                            <span>
                              Transportadora
                            </span>

                            <select
                              value={transportadoraInput}
                              onChange={(e) => {

                                const value = e.target.value;

                                setTransportadoraInput(value);
                                if (value === "Mensajería Interna") {
                                  setGuiaInput("98559603");
                                } else if (value === "Personal") {
                                  setGuiaInput("10000000");
                                  setValorEnvioInput("0");
                                } else {
                                  setGuiaInput("");
                                  setValorEnvioInput("");

                                }

                              }}
                            >
                              <option value="">
                                Seleccionar
                              </option>

                              <option value="Envía">
                                Envía
                              </option>

                              <option value="Interrapidísimo">
                                Interapidísimo
                              </option>

                              <option value="Mensajería Interna">
                                Mensajería Interna
                              </option>

                              <option value="Personal">
                                Personal
                              </option>

                              <option value="Proveedor">
                                Proveedor
                              </option>

                            </select>

                          </div>

                          <div className="dx-line-divider" />

                          <div className="dx-line-item">

                            <span>
                              Número de guía
                            </span>

                            <input
                              type="number"
                              placeholder="Ej: 10425786"
                              value={guiaInput}
                              disabled={[
                                "Mensajería Interna",
                                "Personal"
                              ].includes(transportadoraInput)}

                              onChange={(e) =>
                                setGuiaInput(e.target.value)
                              }

                            />

                          </div>

                          <div className="dx-line-divider" />

                          <div className="dx-line-item">

                            <span>
                              Valor envío
                            </span>

                            <input
                              type="number"
                              placeholder="Ej: 15000"
                              value={valorEnvioInput}

                              disabled={
                                transportadoraInput === "Personal"
                              }

                              onChange={(e) =>
                                setValorEnvioInput(e.target.value)
                              }

                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                {detalleDespacho.fechaLegalizacion && (
                  <div className="g360-legalizacion-footer">
                    <span>Legalizado el</span>

                    <strong>
                      {new Date(
                        detalleDespacho.fechaLegalizacion
                      ).toLocaleString("es-CO")}
                    </strong>
                  </div>
                )}

                {/* ACCIONES */}

                <div className="g360-actions">

                  {/* ===================================== */}
                  {/* SI ESTÁ DEVUELTO → SOLO CERRAR */}
                  {/* ===================================== */}

                  {esDevuelto ? (

                    <button
                      className="inv-btn-ghost"
                      onClick={cerrarDetalle}
                    >
                      Cerrar
                    </button>

                  ) : (

                    <>

                      {/* CERRAR */}

                      <button
                        className="inv-btn-ghost"
                        onClick={cerrarDetalle}
                      >
                        Cerrar
                      </button>

                      {/* ============================= */}
                      {/* DIGITALES */}
                      {/* ============================= */}

                      {detalleDespacho.tipoDespacho === "digital" && (

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap"
                          }}
                        >

                          {detalleDespacho.digitalAssets?.length > 0 ? (

                            <>

                              <a
                                href={`/mis-bonos/${detalleDespacho._id}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  textDecoration: "none"
                                }}
                              >

                                <button
                                  className="inv-btn-primary"
                                  type="button"
                                >
                                  Ver bonos
                                </button>

                              </a>

                              <button
                                className="inv-btn-primary"
                                onClick={() =>
                                  reenviarBonos(detalleDespacho._id)
                                }
                              >
                                Reenviar bonos
                              </button>

                            </>

                          ) : (

                            (detalleDespacho.estado || "").toLowerCase() ===
                            "pendiente_asignacion" && (

                              <button
                                className="inv-btn-primary"
                                disabled={asignandoBonos}
                                onClick={() =>
                                  asignarBonos(detalleDespacho._id)
                                }
                              >
                                {asignandoBonos
                                  ? "Asignando..."
                                  : "Asignar bonos"}
                              </button>

                            )

                          )}

                        </div>
                      )}

                      {/* ============================= */}
                      {/* SERVICIOS */}
                      {/* ============================= */}

                      {detalleDespacho.tipoDespacho === "servicio" &&
                        detalleDespacho.estado !== "completado" && (

                          <>

                            <button
                              className="inv-btn-primary"
                              onClick={() => {

                                window.location.href = `mailto:proveedor@correo.com
                       ?subject=${encodeURIComponent(
                                  `Solicitud de servicio #${detalleDespacho.codigo} – Convenio Fondo de Empleados ManpowerGroup`
                                )}
                       &body=${encodeURIComponent(`
         
                       Estimado proveedor, reciba un cordial saludo.
         
                       Desde el Fondo de Empleados de ManpowerGroup, nos permitimos remitir la siguiente solicitud, correspondiente a una compra realizada por uno de nuestros asociados a través del convenio vigente.
         
                       🟡 DATOS DEL ASOCIADO
         
                       Identificación:
                      ${detalleDespacho.identificacion || "—"}
         
                       Nombre:
                       ${detalleDespacho.cliente || "—"}
         
                       Celular:
                       ${detalleDespacho.celular || "—"}
         
                       Correo:
                       ${detalleDespacho.email || "—"}
         
         
                       🟢 DATOS DEL DESTINO
         
                       Departamento:
                       ${detalleDespacho.departamento || "—"}
         
                       Ciudad:
                       ${detalleDespacho.ciudad || "—"}
         
                       Barrio:
                       ${detalleDespacho.barrio || "—"}
         
                       Dirección:
                       ${detalleDespacho.direccion || "—"}
         
         
                       🔴 DATOS DE LA ORDEN
         
                       ${detalleDespacho.productos
                                    ?.map(
                                      (p) =>
                                        `• ${p.nombre} - Cantidad: ${p.cantidad}`
                                    )
                                    .join("\n")}
         
                       Agradecemos su gestión para proceder con el despacho / asignación / atención del servicio.
         
                       Gracias.
                       `)}`;

                              }}
                            >
                              Abrir correo
                            </button>

                            <button
                              className="inv-btn-primary"
                              onClick={async () => {

                                await actualizarEstado(
                                  detalleDespacho._id,
                                  {
                                    estado: "completado",
                                    fechaCompletado: new Date(),
                                  }
                                );

                              }}
                            >
                              Confirmar servicio
                            </button>

                          </>
                        )}

                      {/* ============================= */}
                      {/* FISICOS */}
                      {/* ============================= */}

                      {detalleDespacho.tipoDespacho === "fisico" && (

                        <>

                          {/* CONFIRMAR DESPACHO */}

                          {["creado", "pendiente_guia"].includes(
                            (detalleDespacho.estado || "").toLowerCase()
                          ) && (

                              <button
                                className="inv-btn-primary"
                                onClick={async () => {

                                  if (!transportadoraInput) {

                                    return toast.warn(
                                      "Selecciona una transportadora."
                                    );

                                  }

                                  if (!guiaInput?.trim()) {

                                    return toast.warn(
                                      "Debes ingresar un número de guía."
                                    );

                                  }

                                  if (
                                    valorEnvioInput === "" ||
                                    valorEnvioInput === null ||
                                    valorEnvioInput === undefined
                                  ) {

                                    return toast.warn(
                                      "Debes ingresar el valor del envío."
                                    );

                                  }

                                  await actualizarEstado(
                                    detalleDespacho._id,
                                    {

                                      transportadora:
                                        transportadoraInput,

                                      guia:
                                        guiaInput.trim(),

                                      valorEnvio:
                                        Number(valorEnvioInput),

                                      estado: "completado",

                                      fechaCompletado:
                                        new Date(),

                                    }
                                  );

                                }}
                              >
                                Confirmar orden
                              </button>

                            )}


                          {/* LEGALIZAR CONTABILIDAD */}

                          {(detalleDespacho.estado || "").toLowerCase() === "completado" &&
                            !detalleDespacho.legalizadoContabilidad && (

                              <button
                                className="inv-btn-primary"
                                onClick={() => {

                                  const productosTexto =
                                    detalleDespacho.productos
                                      ?.map((p) => {

                                        const sku =
                                          p.codigo ||
                                          p.sku ||
                                          p.SKU ||
                                          "-";

                                        const coste =
                                          Number(p.costPrice || 0);

                                        const venta =
                                          Number(p.salePrice || 0);

                                        return `
                                 • SKU: ${sku}
                                   Producto: ${p.nombre}
                                   Cantidad: ${p.cantidad}
                                   Precio coste: $${coste.toLocaleString("es-CO")}
                                   Precio venta: $${venta.toLocaleString("es-CO")}
                                 `;
                                      })
                                      .join("\n");

                                  const totalCoste =
                                    detalleDespacho.productos?.reduce(
                                      (acc, p) =>
                                        acc +
                                        (
                                          Number(p.costPrice || 0) *
                                          Number(p.cantidad || 1)
                                        ),
                                      0
                                    ) || 0;

                                  const totalVenta =
                                    detalleDespacho.productos?.reduce(
                                      (acc, p) =>
                                        acc +
                                        (
                                          Number(p.salePrice || 0) *
                                          Number(p.cantidad || 1)
                                        ),
                                      0
                                    ) || 0;

                                  const valorEnvio =
                                    Number(
                                      detalleDespacho.valorEnvio || 0
                                    );

                                  const asunto =
                                    `Legalización de ${detalleDespacho.esBeneficio ? "beneficio" : "venta"} | Orden #${detalleDespacho.codigo} | ${detalleDespacho.identificacion} - ${detalleDespacho.cliente}`;

                                  const cuerpo = `
                           Cordial saludo,
                   
                           Solicito por favor la legalización contable de la siguiente orden.
                   
                           DATOS DEL ASOCIADO
                   
                           Identificación:
                           ${detalleDespacho.identificacion || "-"}
                   
                           Nombre:
                           ${detalleDespacho.cliente || "-"}
                           
                           Celular:
                           ${detalleDespacho.celular || "-"}
                           
                           ------------------------------------------------
                           
                           PRODUCTOS
                           
                           ${productosTexto}
                           
                           ------------------------------------------------
                           
                           TIPO DE LEGALIZACIÓN
                           
                           ${detalleDespacho.esBeneficio
                                      ? "BENEFICIO"
                                      : "VENTA"}
                           
                           ${detalleDespacho.esBeneficio
                                      ? `Programa:
                           ${detalleDespacho.programaBeneficio || "-"}`
                                      : ""}
                           
                           ------------------------------------------------
                           
                           VALORES
                           
                           ${detalleDespacho.esBeneficio
                                      ? `
                           Valor productos (coste):
                           $${totalCoste.toLocaleString("es-CO")}
                           
                           Costo envío:
                           $${valorEnvio.toLocaleString("es-CO")}
                           
                           TOTAL LEGALIZACIÓN:
                           $${(totalCoste + valorEnvio).toLocaleString("es-CO")}
                           `
                                      : `
                           Valor venta:
                           $${totalVenta.toLocaleString("es-CO")}
                                   
                           Costo envío:
                           $${valorEnvio.toLocaleString("es-CO")}
                           
                           TOTAL:
                           $${(totalVenta + valorEnvio).toLocaleString("es-CO")}
                           `
                                    }
                           
                           ------------------------------------------------
                           
                           Gracias,
                           `;

                                  window.location.href =
                                    `mailto:jpradar@fondomanpower.com` +
                                    `?subject=${encodeURIComponent(asunto)}` +
                                    `&body=${encodeURIComponent(cuerpo)}`;

                                  setShowLegalizarModal(true);

                                }}
                              >
                                Legalizar orden
                              </button>

                            )}

                        </>
                      )}

                    </>

                  )}

                </div>

              </div>
            </div>,
            document.body
          )
        )}

        {showEditarDireccion && (
          createPortal(
            <div
              className="desp-modal-overlay"
              onClick={() => setShowEditarDireccion(false)}
            >

              <div
                className="g360-detalle-modal"
                style={{ maxWidth: "800px" }}
                onClick={(e) => e.stopPropagation()}
              >

                <div className="g360-detalle-header-edit">

                  <h2>Editar Dirección</h2>

                  <p>
                    Actualiza la información de entrega de la orden.
                  </p>

                </div>

                <div className="dx-section">

                  <div className="dx-line-card">

                    <div className="dx-line-item">

                      <span>Departamento</span>

                      <input
                        className="dx-edit-input"
                        type="text"
                        value={direccionEdit.departamento}
                        onChange={(e) =>
                          setDireccionEdit({
                            ...direccionEdit,
                            departamento: e.target.value,
                          })
                        }
                      />

                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">

                      <span>Ciudad</span>

                      <input
                        className="dx-edit-input"
                        type="text"
                        value={toTitleCase(direccionEdit.ciudad)}
                        onChange={(e) =>
                          setDireccionEdit({
                            ...direccionEdit,
                            ciudad: e.target.value,
                          })
                        }
                      />

                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">

                      <span>Barrio</span>

                      <input
                        className="dx-edit-input"
                        type="text"
                        value={toTitleCase(direccionEdit.barrio)}
                        onChange={(e) =>
                          setDireccionEdit({
                            ...direccionEdit,
                            barrio: e.target.value,
                          })
                        }
                      />

                    </div>

                    <div className="dx-line-divider" />

                    <div className="dx-line-item">

                      <span>Dirección</span>

                      <input
                        className="dx-edit-input"
                        type="text"
                        value={toTitleCase(direccionEdit.direccion)}
                        onChange={(e) =>
                          setDireccionEdit({
                            ...direccionEdit,
                            direccion: e.target.value,
                          })
                        }
                      />

                    </div>

                  </div>

                </div>

                <div className="g360-actions">

                  <button
                    className="inv-btn-ghost"
                    onClick={() =>
                      setShowEditarDireccion(false)
                    }
                  >
                    Cancelar
                  </button>

                  <button
                    className="inv-btn-primary"
                    onClick={async () => {

                      await actualizarEstado(
                        detalleDespacho._id,
                        {
                          departamento:
                            direccionEdit.departamento,

                          ciudad:
                            direccionEdit.ciudad,

                          barrio:
                            direccionEdit.barrio,

                          direccion:
                            direccionEdit.direccion,
                        }
                      );

                      setDetalleDespacho({
                        ...detalleDespacho,
                        ...direccionEdit,
                      });

                      setShowEditarDireccion(false);

                    }}
                  >
                    Guardar cambios
                  </button>

                </div>

              </div>

            </div>,
            document.body
          )
        )}

        {showLegalizarModal && (
          <div
            className="desp-modal-overlay"
            onClick={() =>
              setShowLegalizarModal(false)
            }
          >

            <div
              className="desp-modal modal-animate"
              onClick={(e) =>
                e.stopPropagation()
              }
              style={{
                maxWidth: "500px"
              }}
            >

              <div className="desp-modal-header">

                <h3>
                  Confirmar legalización
                </h3>

              </div>

              <div
                style={{
                  padding: "25px",
                  textAlign: "center",
                }}
              >

                <p
                  style={{
                    fontSize: "15px",
                    color: "#374151",
                    lineHeight: 1.6,
                    margin: 0,
                  }}
                >
                  ¿Confirmas que el correo de
                  legalización fue enviado
                  correctamente a Contabilidad?
                </p>

              </div>

              <div className="desp-modal-actions">

                <button
                  className="desp-btn-secondary"
                  onClick={() =>
                    setShowLegalizarModal(false)
                  }
                >
                  Cancelar
                </button>

                <button
                  className="desp-btn-primary"
                  onClick={confirmarLegalizacion}
                >
                  Sí, legalizar
                </button>

              </div>

            </div>

          </div>

        )}

      </div>

    </div>

    </>
    
  );
}

export default Despachos;
